var _ = require('underscore');
var $ = require('jquery');

var cropImage = function(toCropNr) {
/*
    if(previewJcrop) {
        previewJcrop.destroy();
    }*/

    var toCrop = $('.new_image').eq(toCropNr).find('img.file-img:first');
    var parent = $(toCrop).parents('.new_image');

    if(parent.data('format') !== 'JPEG') {
        console.warn('Can\'t crop file format:' + parent.data('format'));
        return false;
    }

    var aspectRatio = getAspectRatio();
    console.log("Aspect ratio: ", aspectRatio);

    if(aspectRatio === false) {
        console.warn('Can\'t crop file, unrecognized aspectRatio');
        return false;
    }
    var imgTrueWidth = parent.data('widthpx');
    var imgTrueHeight = parent.data('heightpx');
    var imgWidth = $(toCrop).width();
    var imgHeight = $(toCrop).height();

    var scale = imgWidth / imgTrueWidth;
    console.log("Scale: ", scale);
    scale = 1;
    console.log("Scale: ", scale);

    var cropX = scale * parent.data('cropx');
    var cropY = scale * parent.data('cropy');
    var cropWidth = scale * parent.data('cropwidth');
    var cropHeight = scale * parent.data('cropheight');

    console.log("To crop size: ", imgWidth, imgHeight);

    if(cropX == 0 && cropY == 0 && cropWidth == 0 && cropHeight == 0) {

        var imageProportion = imgWidth / imgHeight;

        if(imageProportion >= aspectRatio) {

            cropHeight = imgHeight;
            cropWidth = cropHeight * aspectRatio;
            cropX = (imgWidth - cropWidth) / 2;
            cropY = 0;

        } else if(imageProportion < aspectRatio) {

            cropWidth = imgWidth;
            cropHeight = cropWidth / aspectRatio;
            cropY = (imgHeight - cropHeight) / 2;
            cropX = 0;
        }
        console.log("Image proportion: ", imageProportion);
    }
    console.log("Image crop: ", cropX, cropY, cropWidth, cropHeight);

    var changeTimeout;
    origin = [cropX, cropY, cropX + cropWidth, cropY + cropHeight];
    const stage = Jcrop.attach(toCrop[0]);
    const widget = Jcrop.Widget.create();
    const rect = Jcrop.Rect.fromPoints(
        [cropX,cropY],
        [cropWidth, cropHeight]
    );
    const options = {
        aspectRatio: rect.aspect
    };
    stage.newWidget(rect, options);
    stage.listen('crop.change', function(widget, e) {
        console.log(widget.pos);
        var c = widget.pos;

        var cropX = c.x / scale;
        var cropY = c.y / scale;
        var cropWidth = c.w / scale;
        var cropHeight = c.h / scale;

        parent.data('cropx', cropX);
        parent.data('cropy', cropY);
        parent.data('cropwidth', cropWidth);
        parent.data('cropheight', cropHeight);

        console.log("Updating crop data: ", parent.data());
        var scale2 = imgTrueWidth / imgWidth;

        $.ajax({
            url: RoutingS1.generate('fileUpdateData'),
            type: 'POST',
            data: {
                updateAction: 'crop',
                type: parent.data('type'),
                sessionId: parent.data('sessionid'),
                cropX: cropX * scale2,
                cropY: cropY * scale2,
                cropWidth: cropWidth * scale2,
                cropHeight: cropHeight * scale2,
                scale: scale,
                scale2: scale2,
                cropReal: {
                    x: cropX * scale,
                    y: cropY * scale,
                    w: cropWidth * scale,
                    h: cropHeight * scale
                },
                cropReal2: {
                    x: cropX * scale2,
                    y: cropY * scale2,
                    w: cropWidth * scale2,
                    h: cropHeight * scale2
                },
                cropWidgetPos: widget.pos,
                imageVisible: {
                    w: imgWidth,
                    h: imgHeight
                },
                imageOriginal: {
                    w: imgTrueWidth,
                    h: imgTrueHeight
                }
            }
        });
    });
};

var getAspectRatio = function() {
    var sizeId = $('#order_size').val();
    var aspectRatio = false;

    for(var i in productSizes) {
        if(productSizes[i].id == sizeId) {
            console.log("Current size: ", productSizes[i]);
            aspectRatio = productSizes[i].width / productSizes[i].height;
            break;
        }
    }

    if(!aspectRatio) {
        var width = $('#order_size_width:visible').val();
        var height = $('#order_size_height:visible').val();

        aspectRatio = width / height;

        if(_.isNaN(aspectRatio)) {
            aspectRatio = false;
        }
    }

    return aspectRatio;
};
window.cropImage = cropImage;
window.getAspectRatio = getAspectRatio;

$(document).ready(function() {
    if (!_.isUndefined(croppingEnabled) && croppingEnabled) {
        $('#order_size').change(function() {
            cropImage(currentlySelectedFile);
        });

        $('#order_size_width, #order_size_height').keyup(function() {
            cropImage(currentlySelectedFile);
        });

        cropImage(currentlySelectedFile);
    }
    if (!_.isUndefined(fileMultiPrintEnabled) && fileMultiPrintEnabled) {
        $(document).on('change', '.prints-number', function() {
            var value = parseInt($(this).val());

            if(_.isNaN(value) || value < 1) {
                value = 1;
            }

            if(value !== $(this).val()) {
                $(this).val(value);

                $.ajax({
                    url: Routing.generate('fileUpdateData'),
                    type: 'POST',
                    data: {
                        updateAction: 'printsNumber',
                        type: $(this).data('type'),
                        sessionId: $(this).data('id'),
                        printsNumber: value
                    }
                });

                $(document).trigger('mnumi:order:recalculate.count');
            }
        });
    }
});
